module.exports = __webpack_public_path__ + "static/media/coffe-break-ad2.25638074.jpeg";